module.exports = __webpack_public_path__ + "img/food-9.0a9f1df5.jpg";